<template>
  <div
    class="d-flex justify-content-between align-items-center py-5 border-bottom"
    style="margin-bottom: 3rem"
  >
    <div class="d-none d-md-block">
      <div class="btn btn-black" style="opacity: 0" v-if="!username">
        Sign in
      </div>
      <div class="btn btn-black rounded-pill" style="opacity: 0" v-else>
        {{ username }}
      </div>
    </div>
    <router-link
      to="/"
      class="d-flex align-items-center text-decoration-none text-black"
    >
      <img src="@/assets/logo.png" width="40" alt="logo" />
      <p class="mb-0 fw-700 fz-30 ml-4">
        <span style="color: #03428b"><b>SILAJU</b></span>
      </p>
    </router-link>
    <div class="">
      <v-btn
        class="btn btn-black rounded-pill"
        v-if="!username"
        @click="$router.push('/login')"
        >Sign in</v-btn
      >
      <v-menu :nudge-width="150" offset-y v-else>
        <template v-slot:activator="{ on, attrs }">
          <v-btn class="btn btn-black rounded-pill" v-bind="attrs" v-on="on">
            {{ username }}
          </v-btn>
        </template>
        <v-list class="menu-primary">
          <v-list-item @click="() => $router.push('/history')">
            Riwayat Pelaporan
          </v-list-item>
          <v-list-item @click="handleLogout"> Keluar </v-list-item>
        </v-list>
      </v-menu>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";

export default {
  name: "Topbar",
  data() {
    return {
      username: localStorage.getItem("username"),
    };
  },
  methods: {
    handleLogout() {
      Swal.fire({
        title: "Yakin ingin Keluar?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Yakin",
      }).then((result) => {
        if (result.isConfirmed) {
          localStorage.clear();
          this.$router.push("/login");
        }
      });
    },
  },
};
</script>
